import HomeDownPaymentPage from "./HomeDownPaymentPage";

export default HomeDownPaymentPage;
